export const PACKAGE_DEFAULT = '미적용';

export const LABEL_DEFAULT_DATE = '직접 선택';

export const ALIAS_FOR_DATEPICKER = 'date';